import AutoFormattedMessage from 'components/AutoFormattedMessage'

export default AutoFormattedMessage
